import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Box, Typography } from '@mui/material';

import InfoIcon from '@mui/icons-material/Info';

import { BugReportStatus } from '../../../../shared/constants';
import { Paths } from '../../../../shared/paths';
import theme from '../../../../styles/theme';
import { IBugReport } from '../../../../types/interfaces/bug-report';
import { useStyles } from './BugReportItem.styles';
import AppEntityAvatar from '../../../../components/designe/app-entity-avatar/AppEntityAvatar';

interface IBugReportItemProps {
  report: IBugReport;
  onClick: () => void;
}

export default function BugReportItem(props: IBugReportItemProps) {
  const { t, i18n } = useTranslation();
  const { classes } = useStyles(theme);
  const { report, onClick } = props;

  return (
    <Box className={classes.bugReportItemWrapper} onClick={onClick}>
      <AppEntityAvatar entity={report.creator} />
      <Box className={classes.bugReportItemInfo}>
        <Typography variant="text-md-sb">{report.title}</Typography>
        <Typography variant="text-md">{report.type.name}</Typography>
      </Box>
      {report.status === BugReportStatus.requested && <InfoIcon />}
    </Box>
  );
}
